import { date } from "zod";
import { OrdersType } from "../shared/interfaces/requests.interface";
import axiosConfig from "../util/axiosConfig";
import requestErrorHandler from "../util/requestErrorHandler";

const BASE_URL = process.env.REACT_APP_BACKEND_URL!;

export const getAllRequest = async (status?: string, pagination?: any) => {
  let requests: OrdersType[] = [];
  let page

  try {
    const response = await axiosConfig.get(
      `${BASE_URL}/renter/rental-request`,
      { params: { status, pagination } } 
    );
    const { data } = response;
    requests = data?.data.sort(
      (reqFirst: OrdersType, reqSec: OrdersType) =>
        new Date(reqSec.createdAt).getTime() -
        new Date(reqFirst.createdAt).getTime()
    );
    page = data?.pagination;
    return { requests, pagination: page };
  } catch (error) {
    console.error("Error fetching Renter orders:", error);
    requestErrorHandler('Unable to fetch Renter orders');
    return { requests, pagination: page };
  }
};
